import { getFileSizeFromBase64 } from "./getFileSizeFromBase64";
import { removeFromStorage } from "./removeFromStorage";
import { uploadToStorage } from "./uploadToStorage";

export async function saveFileChanges(editFiles, project_uid, project_id) {
  var files = [];
  var sizeChange = 0;
  for (var i = 0; i < editFiles.length; i++) {
    if (editFiles[i].id.startsWith("new_") && editFiles[i].deleted === false) {
      editFiles[i].id = editFiles[i].id.slice(4);
      const fp = await uploadToStorage(
        `users/${project_uid}/projects/${project_id}/attachments/${editFiles[i]["id"]}/${editFiles[i]["name"]}`,
        editFiles[i]["file"],
      );
      editFiles[i]["file"] = fp;
      sizeChange += editFiles[i]["size"];
      files.push(editFiles[i]);
    } else if (!editFiles[i].id.startsWith("new_") && editFiles[i].deleted) {
      //delete the existing file
      sizeChange -= editFiles[i]["size"];
      await removeFromStorage(editFiles[i]["file"]);
    } else if (
      editFiles[i].hasOwnProperty("isDrawn") &&
      editFiles[i].isDrawn &&
      !editFiles[i].deleted
    ) {
      //replace existing file
      var newFileSize = getFileSizeFromBase64(editFiles[i]["file"]);
      editFiles[i]["size"] = newFileSize;
      sizeChange += newFileSize - editFiles[i]["size"];
      const fp = await uploadToStorage(
        `users/${project_uid}/projects/${project_id}/attachments/${editFiles[i]["id"]}/${editFiles[i]["name"]}`,
        editFiles[i]["file"],
      );
      editFiles[i]["file"] = fp;
      delete editFiles[i]["isDrawn"];

      files.push(editFiles[i]);
    } else {
      // do nothing since no file movement is needed
      files.push(editFiles[i]);
    }
  }
  return { files, sizeChange };
}
